export const CATEGORIES_HEADER_TITLES = {
	ID: 'ID',
	NAME: 'Імʼя',
	CREATED_AT: 'Створено',
	SEQUENCE_NUMBER: 'Порядковий номер',
	SERVICES_COUNT: 'К-сть сервісів'
};
